module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/caste-verification/caste-verification.component.css
// module id = ./src/app/caste-verification/caste-verification.component.css
// module chunks = main